import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import React, { useState, useEffect } from 'react';
import vacaImagem from '../../assets/img/vaca.svg'
import vendaTotalImagem from '../../assets/img/vendatotal.svg'
import { post } from '../../services/api'
import { ThreeDots } from "react-loader-spinner";
import Select from 'react-select';
import leaoImagem from '../../assets/img/leao.svg'
import pinguimImagem from '../../assets/img/pinguim.svg'

function TrvInterface({ dados }) {
    const selectClassificacaoStyle = {
        control: (provided) => ({
            ...provided,
            minHeight: '24px',
            height: '24px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '24px',
            padding: '0 6px',
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '24px',
        }),
    };

    const sliderHandleStyle = {
        borderColor: 'black',
        backgroundColor: 'black',
        boxShadow: 'none'
    };

    const sliderTrackStyle = {
        backgroundColor: 'black',
    };

    const mensagemUsuario = 'A simulação salarial é um exercício que calcula possíveis ganhos financeiros com base em diferentes cenários. Esta é uma simulação baseada em projeção de venda sem contar possíveis penalizações ou reduções de venda.'

    let parametroPrimeiroSlider = 0;
    let parametroTerceiroSlider = 0;

    if (dados) {
        if (dados.trvInfoUsuario.cargo == 'GERENTE_LOJA' || dados.trvInfoUsuario.cargo == 'GERENTE_REGIONAL') {
            parametroPrimeiroSlider = dados.valorSliderVendaTotal;
            parametroTerceiroSlider = dados.vacaLeiteiraPercentualSlider;
        }

        if (dados.trvInfoUsuario.cargo == 'VENDEDOR') {
            parametroPrimeiroSlider = dados.valorSliderMercantil;
            parametroTerceiroSlider = dados.valorSliderServicos;
        }
    }

    const vendedoresAtivosRegiao = dados ? dados.vendedoresAtivos : 0;
    const classificacao = dados ? { value: dados.nivelGeralProjetado, label: dados.nivelGeralProjetado } : { value: 'E', label: 'E' };

    const [valorPrimeiroSlider, setValorPrimeiroSlider] = useState(parametroPrimeiroSlider);
    const [valorTerceiroSlider, setValorTerceiroSlider] = useState(parametroTerceiroSlider);
    const [vendedoresAtivosSlider, setVendedoresAtivosSlider] = useState(vendedoresAtivosRegiao);
    const [trvSimulado, setTrvSimulado] = useState(0);
    const [trvPlusSimulado, setTrvPlusSimulado] = useState(0);
    const [trvPlusPercentual, setTrvPlusPercentual] = useState(0);
    const [vendaTotalVendedorRegiaoSimulado, setVendaTotalVendedorRegiaoSimulado] = useState(0);
    const [classificacaoSelect, setClassificacaoSelect] = useState(classificacao);
    const [carregandoLimpar, setCarregandoLimpar] = useState(false);
    const [carregandoSimular, setCarregandoSimular] = useState(false);

    useEffect(() => {
        calcularTrvSimuladoSlider(parametroPrimeiroSlider, parametroTerceiroSlider, vendedoresAtivosRegiao, classificacao.value);
    }, []);

    function resetarDados() {
        setValorPrimeiroSlider(parametroPrimeiroSlider);
        setValorTerceiroSlider(parametroTerceiroSlider);
        setVendedoresAtivosSlider(vendedoresAtivosRegiao);
        calcularTrvSimuladoSlider(parametroPrimeiroSlider, parametroTerceiroSlider, vendedoresAtivosRegiao, classificacao.value, true);
        setClassificacaoSelect(classificacao);
    }

    function primeiroSliderChange(newValue) {
        setValorPrimeiroSlider(newValue);
    }

    function terceiroSliderChange(newValue) {
        setValorTerceiroSlider(newValue);
    }

    function handleSliderVendedoresAtivosChange(newValue) {
        setVendedoresAtivosSlider(newValue);
    }

    function formatoMoeda(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }

    function formatoPercentual(value) {
        return `${(parseFloat(value)).toFixed(2).replace('.', ',')}%`;
    }

    async function calcularTrvSimuladoSlider(parametroPrimeiroSlider = null, parametroTerceiroSlider = null, vendedoresAtivos = null, classificacao = null, limpar = false) {
        try {
            if (parametroPrimeiroSlider == null || parametroTerceiroSlider == null) {
                parametroPrimeiroSlider = valorPrimeiroSlider;
                parametroTerceiroSlider = valorTerceiroSlider;
                vendedoresAtivos = vendedoresAtivosSlider;
                classificacao = classificacaoSelect.value;
            }

            const [mes, ano] = dados.trvInfoUsuario.mesAno.split('-');
            const idVendedor = dados.trvInfoUsuario.idVendedor;
            const cargo = dados.trvInfoUsuario.cargo;

            const requisicao = {
                mes: mes,
                ano: ano,
                idVendedor: idVendedor,
                cargo: cargo,
                parametroPrimeiroSlider: parametroPrimeiroSlider,
                parametroTerceiroSlider: parametroTerceiroSlider,
                vendedoresAtivos: vendedoresAtivos,
                classificacao: classificacao,
                dadosTrv: dados
            };

            if (limpar) {
                setCarregandoLimpar(true);
            } else {
                setCarregandoSimular(true);
            }

            const response = await post('/trv/trvsimulado', requisicao);

            setCarregandoLimpar(false);
            setCarregandoSimular(false);

            setTrvSimulado(response.salario);
            setTrvPlusSimulado(response.plus);
            setVendaTotalVendedorRegiaoSimulado(response.vendaTotalVendedorRegiao);
            setTrvPlusPercentual(response.plus_percentual);
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    const handleChangeClassificacao = async (selectedOption) => {
        setClassificacaoSelect(selectedOption);
    };

    function dadosExistentes(valor) {
        return parseFloat(valor) > 0;
    }

    function carregaInterfacePersonalizadaPorCargo() {
        try {
            switch (dados.trvInfoUsuario.cargo) {
                case 'GERENTE_REGIONAL':
                    return {
                        classCampos: 'mb-4',
                        primeiroTitulo: 'TRV',
                        labelPrimeiroCampo: 'Venda Total Realizada por Vendedor',
                        labelSegundoCampo: 'Venda Total Projetada por Vendedor',
                        labelTerceiroCampo: 'MGC + Juros Realizado',
                        labelQuartoCampo: 'Vendedores Ativos',
                        labelQuintoCampo: 'TRV Realizado',
                        labelSextoCampo: 'TRV Projetado',
                        dadosPrimeiroCampo: dadosExistentes(dados.vendaTotalRealizado) ? formatoMoeda(dados.vendaTotalRealizado) : 'R$ 0,00',
                        dadosSegundoCampo: dadosExistentes(dados.vendaTotalProjetado) ? formatoMoeda(dados.vendaTotalProjetado) : 'R$ 0,00',
                        dadosTerceiroCampo: dadosExistentes(dados.vacaLeiteiraPercentual) ? formatoPercentual(dados.vacaLeiteiraPercentual) : '0%',
                        dadosQuartoCampo: dadosExistentes(dados.vendedoresAtivos) ? dados.vendedoresAtivos : 0,
                        classMensagemUsuario: 'mt-4',
                        classVisor: 'shadow-inner shadow-gray-500 rounded-lg border border-8 border-gray-500 py-4 px-3 leading-tight focus:outline-none focus:shadow-outline text-3xl md:text-5xl share-tech-regular bg-blue-100',
                        classPrimeiroSlider: 'mt-2',
                        labelPrimeiroSlider: 'Venda Total Projetado',
                        imagemPrimeiroSlider: vendaTotalImagem,
                        minPrimeiroSlider: dados.valorMinimoSliderVendaTotal,
                        maxPrimeiroSlider: dados.valorMaximoSliderVendaTotal,
                        stepPrimeiroSlider: dados.stepSliderVendaTotal,
                        valuePrimeiroSlider: valorPrimeiroSlider,
                        classTerceiroSlider: 'mt-2',
                        labelTerceiroSlider: 'MGC + Juros Projetado',
                        imagemTerceiroSlider: vacaImagem,
                        minTerceiroSlider: dados.valorMinimoSliderVacaLeiteira,
                        maxTerceiroSlider: 100,
                        stepTerceiroSlider: 0.5,
                        valueTerceiroSlider: valorTerceiroSlider,
                        valorFormatadoTerceiroSlider: dadosExistentes(valorTerceiroSlider) ? formatoPercentual(valorTerceiroSlider) : 'R$ 0,00',
                        classBotoesSimulacao: 'mt-2'
                    };

                case 'GERENTE_LOJA':
                    return {
                        classCampos: '',
                        primeiroTitulo: 'TRV',
                        labelPrimeiroCampo: 'Venda Total Realizada',
                        labelSegundoCampo: 'Venda Total Projetada',
                        labelTerceiroCampo: 'MGC + Juros Realizado',
                        labelQuartoCampo: 'MGC + Juros Projetado',
                        labelQuintoCampo: 'TRV Realizado',
                        labelSextoCampo: 'TRV Projetado',
                        dadosPrimeiroCampo: dadosExistentes(dados.vendaTotalRealizado) ? formatoMoeda(dados.vendaTotalRealizado) : 'R$ 0,00',
                        dadosSegundoCampo: dadosExistentes(dados.vendaTotalProjetado) ? formatoMoeda(dados.vendaTotalProjetado) : 'R$ 0,00',
                        dadosTerceiroCampo: dadosExistentes(dados.vacaLeiteiraPercentual) ? formatoPercentual(dados.vacaLeiteiraPercentual) : '0%',
                        dadosQuartoCampo: dadosExistentes(dados.vacaLeiteiraPercentual) ? formatoPercentual(dados.vacaLeiteiraPercentual) : '0%',
                        classMensagemUsuario: 'mt-8',
                        classVisor: 'shadow-inner shadow-gray-500 rounded-lg border border-8 border-gray-500 py-6 px-3 leading-tight focus:outline-none focus:shadow-outline text-3xl md:text-5xl share-tech-regular bg-blue-100',
                        classPrimeiroSlider: 'mt-6',
                        labelPrimeiroSlider: 'Venda Total Projetado',
                        imagemPrimeiroSlider: vendaTotalImagem,
                        minPrimeiroSlider: dados.valorMinimoSliderVendaTotal,
                        maxPrimeiroSlider: dados.valorMaximoSliderVendaTotal,
                        stepPrimeiroSlider: dados.stepSliderVendaTotal,
                        classTerceiroSlider: 'mt-4',
                        labelTerceiroSlider: 'MGC + Juros Projetado',
                        imagemTerceiroSlider: vacaImagem,
                        minTerceiroSlider: dados.valorMinimoSliderVacaLeiteira,
                        maxTerceiroSlider: 100,
                        stepTerceiroSlider: 0.5,
                        valorFormatadoTerceiroSlider: dadosExistentes(valorTerceiroSlider) ? formatoPercentual(valorTerceiroSlider) : '0%',
                        classBotoesSimulacao: 'mt-8'
                    };

                case 'VENDEDOR':
                    return {
                        classCampos: '',
                        primeiroTitulo: 'Comissão',
                        labelPrimeiroCampo: 'Mercantil Realizado',
                        labelSegundoCampo: 'Mercantil Projetado',
                        labelTerceiroCampo: 'Serviços Realizado',
                        labelQuartoCampo: 'Serviços Projetado',
                        labelQuintoCampo: 'Comissão Realizada',
                        labelSextoCampo: 'Comissão Projetada',
                        dadosPrimeiroCampo: dadosExistentes(dados.mercantilRealizado) ? formatoMoeda(dados.mercantilRealizado) : 'R$ 0,00',
                        dadosSegundoCampo: dadosExistentes(dados.mercantilProjetado) ? formatoMoeda(dados.mercantilProjetado) : 'R$ 0,00',
                        dadosTerceiroCampo: dadosExistentes(dados.servicosRealizado) ? formatoMoeda(dados.servicosRealizado) : 'R$ 0,00',
                        dadosQuartoCampo: dadosExistentes(dados.servicosProjetado) ? formatoMoeda(dados.servicosProjetado) : 'R$ 0,00',
                        classMensagemUsuario: 'mt-8',
                        classVisor: 'shadow-inner shadow-gray-500 rounded-lg border border-8 border-gray-500 py-6 px-3 leading-tight focus:outline-none focus:shadow-outline text-3xl md:text-5xl share-tech-regular bg-blue-100',
                        classPrimeiroSlider: 'mt-6',
                        labelPrimeiroSlider: 'Mercantil Projetado',
                        imagemPrimeiroSlider: leaoImagem,
                        minPrimeiroSlider: dados.valorMinimoSliderMercantil,
                        maxPrimeiroSlider: dados.valorMaximoSliderMercantil,
                        stepPrimeiroSlider: dados.stepSliderMercantil,
                        classTerceiroSlider: 'mt-4',
                        labelTerceiroSlider: 'Serviços Projetado',
                        imagemTerceiroSlider: pinguimImagem,
                        minTerceiroSlider: dados.valorMinimoSliderServicos,
                        maxTerceiroSlider: dados.valorMaximoSliderServicos,
                        stepTerceiroSlider: dados.stepSliderServicos,
                        valorFormatadoTerceiroSlider: dadosExistentes(valorTerceiroSlider) ? formatoMoeda(valorTerceiroSlider) : 'R$ 0,00',
                        classBotoesSimulacao: 'mt-8'
                    };
            }
        } catch (error) {
            console.error('Erro: ' + error.message);

        }
    }

    const optionsClassificacoes = (dados && Array.isArray(dados.classificacoes)) ? dados.classificacoes.map((classificacao) => ({
        value: classificacao.nivel,
        label: classificacao.nivel,
    })) : [];

    return (
        <div>
            <section className={`bg-[url(../img/bg-img.png)] bg-cover bg-no-repeat bg-center 2xl:h-[110vh] relative pt-12 pb-24`}>
                <div className="container">
                    <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-1">
                        <div className="relative bg-[#cfd0d4] p-8 shadow-inner shadow-gray-500 rounded-xl border-double border-8 border-gray-400 borda-curvada-calculadora"
                            style={{ minHeight: '600px', width: '100%', maxWidth: '520px' }}>
                            <div className="relative z-10">
                                <h2 className="text-xl fjalla-one-regular mb-4">{carregaInterfacePersonalizadaPorCargo().primeiroTitulo}</h2>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelPrimeiroCampo}</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{carregaInterfacePersonalizadaPorCargo().dadosPrimeiroCampo}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelSegundoCampo}</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{carregaInterfacePersonalizadaPorCargo().dadosSegundoCampo}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelTerceiroCampo}</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{carregaInterfacePersonalizadaPorCargo().dadosTerceiroCampo}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelQuartoCampo}</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{carregaInterfacePersonalizadaPorCargo().dadosQuartoCampo}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelQuintoCampo}</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{dadosExistentes(dados.trvRealizado) ? formatoMoeda(dados.trvRealizado) : 'R$ 0,00'}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelSextoCampo}</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{dadosExistentes(dados.trvProjetado) ? formatoMoeda(dados.trvProjetado) : 'R$ 0,00'}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">Nivel Geral Realizado</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{dados.nivelGeralRealizado ? dados.nivelGeralRealizado : '-'}</div>
                                    </div>
                                    <div className={carregaInterfacePersonalizadaPorCargo().classCampos}>
                                        <label className="block mb-2 text-sm fjalla-one-regular">Nivel Geral Projetado</label>
                                        <div className="shadow-inner shadow-gray-500 rounded py-2 px-3 border-4 border-gray-500 leading-tight share-tech-regular bg-blue-100 w-full"
                                            type="text">{dados.nivelGeralProjetado ? dados.nivelGeralProjetado : '-'}</div>
                                    </div>
                                </div>
                                <div className={carregaInterfacePersonalizadaPorCargo().classMensagemUsuario}>
                                    <textarea readOnly style={{ resize: 'none' }} value={mensagemUsuario}
                                        className="shadow-inner shadow-gray-500 rounded py-2 px-3 leading-tight bg-[#cfd0d4] text-md fira-code w-full"
                                        rows="6"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div className="hidden md:flex flex-col items-center justify-center self-center">
                            <div className="bg-gray-800 w-2 h-6 rounded-full shadow-inner shadow-gray-100"></div>
                            <div className="bg-gray-600 w-2 h-72 shadow-inner shadow-gray-300"></div>
                            <div className="bg-gray-800 w-2 h-6 rounded-full shadow-inner shadow-gray-100"></div>
                        </div>

                        <div className="relative bg-[#cfd0d4] p-8 shadow-inner shadow-gray-50 rounded-xl border-double border-8 border-gray-400 borda-curvada-calculadora"
                            style={{ minHeight: '600px', width: '100%', maxWidth: '520px' }}>
                            <div className="relative z-10">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-md md:text-xl fjalla-one-regular">Simulador de Salário</h2>
                                    <div className="bg-amber-950 w-32 rounded">
                                        <div className="h-6 flex items-center justify-between px-4">
                                            <span className="block w-1 bg-amber-900 h-5 mx-1"></span>
                                            <span className="block w-1 bg-amber-900 h-5 mx-1"></span>
                                            <span className="block w-1 bg-amber-900 h-5 mx-1"></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-12 borda-curvada-visor">
                                    <div type="text" id="inputSalario" value="R$ 6.500,00"
                                        className={carregaInterfacePersonalizadaPorCargo().classVisor}
                                    >
                                        {dadosExistentes(trvSimulado) ? formatoMoeda(trvSimulado) : 'R$ 0,00'}
                                    </div>
                                </div>

                                <div className="mt-6">
                                    <div className='flex items-center'>
                                        <label className="block text-sm fjalla-one-regular">Plus</label>
                                    </div>

                                    <div className='flex'>
                                        <span className="share-tech-regular text-2xl md:text-3x1">{trvPlusPercentual >= 0 ? '+' + formatoPercentual(trvPlusPercentual) : '-'}</span>
                                        &nbsp;
                                        <div className="z-10" style={{ marginTop: '2px' }}>
                                            <Select
                                                name="classificacao"
                                                className="share-tech-regular"
                                                classNamePrefix="react-select"
                                                value={classificacaoSelect}
                                                onChange={handleChangeClassificacao}
                                                options={optionsClassificacoes}
                                                isSearchable={false}
                                                isClearable={false}
                                                isDisabled={false}
                                                styles={selectClassificacaoStyle}
                                            />
                                        </div>
                                        &nbsp;
                                        <span className="share-tech-regular text-2xl md:text-3x1">{dadosExistentes(trvPlusSimulado) ? ' = ' + formatoMoeda(trvPlusSimulado) : '-'}</span>
                                    </div>
                                </div>

                                {dados.trvInfoUsuario.cargo == 'GERENTE_REGIONAL' && (
                                    <div className="mt-4">
                                        <div className='flex items-center'>
                                            <label className="block text-sm fjalla-one-regular">Venda Total Projetado Por Vendedor:</label>
                                            <span className="share-tech-regular ml-2 text-lg">{dadosExistentes(vendaTotalVendedorRegiaoSimulado) ? formatoMoeda(vendaTotalVendedorRegiaoSimulado) : 'R$ 0,00'}</span>
                                        </div>
                                    </div>
                                )}


                                <div className={carregaInterfacePersonalizadaPorCargo().classPrimeiroSlider}>
                                    <div className='flex items-center'>
                                        <label className="block text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelPrimeiroSlider}</label>
                                        <img src={carregaInterfacePersonalizadaPorCargo().imagemPrimeiroSlider} alt="Slider 1" className="ml-2 mb-1 w-10 h-10" />
                                    </div>

                                    <Slider
                                        min={carregaInterfacePersonalizadaPorCargo().minPrimeiroSlider}
                                        max={carregaInterfacePersonalizadaPorCargo().maxPrimeiroSlider}
                                        step={carregaInterfacePersonalizadaPorCargo().stepPrimeiroSlider}
                                        value={valorPrimeiroSlider}
                                        onChange={primeiroSliderChange}
                                        style={{ marginRight: '12px' }}
                                        className="w-full"
                                        trackStyle={sliderTrackStyle}
                                        handleStyle={sliderHandleStyle}
                                    />
                                    <span className="share-tech-regular ml-2 text-lg">{dadosExistentes(valorPrimeiroSlider) ? formatoMoeda(valorPrimeiroSlider) : 'R$ 0,00'}</span>
                                </div>


                                {dados.trvInfoUsuario.cargo == 'GERENTE_REGIONAL' && (
                                    <div className="mt-2">
                                        <div className='flex items-center'>
                                            <label className="block text-sm fjalla-one-regular">Vendedores Ativos</label>
                                        </div>

                                        <Slider
                                            min={dados.valorMinimoSliderVendoresAtivos}
                                            max={dados.valorMaximoSliderVendoresAtivos}
                                            step={dados.stepSliderVendedoresAtivos}
                                            value={vendedoresAtivosSlider}
                                            onChange={handleSliderVendedoresAtivosChange}
                                            style={{ marginRight: '12px' }}
                                            className="w-full"
                                            trackStyle={sliderTrackStyle}
                                            handleStyle={sliderHandleStyle}
                                        />
                                        <span className="share-tech-regular ml-2 text-lg">{dadosExistentes(vendedoresAtivosSlider) ? vendedoresAtivosSlider : 0}</span>
                                    </div>
                                )}

                                <div className={carregaInterfacePersonalizadaPorCargo().classTerceiroSlider}>
                                    <div className='flex items-center'>
                                        <label className="block text-sm fjalla-one-regular">{carregaInterfacePersonalizadaPorCargo().labelTerceiroSlider}</label>
                                        <img src={carregaInterfacePersonalizadaPorCargo().imagemTerceiroSlider} alt="Slider 3" className="ml-2 mb-1 w-10 h-10" />
                                    </div>

                                    <Slider
                                        min={carregaInterfacePersonalizadaPorCargo().minTerceiroSlider}
                                        max={carregaInterfacePersonalizadaPorCargo().maxTerceiroSlider}
                                        step={carregaInterfacePersonalizadaPorCargo().stepTerceiroSlider}
                                        value={valorTerceiroSlider}
                                        onChange={terceiroSliderChange}
                                        style={{ marginRight: '12px' }}
                                        trackStyle={sliderTrackStyle}
                                        handleStyle={sliderHandleStyle}
                                    />
                                    <span className="share-tech-regular ml-2 text-lg">{carregaInterfacePersonalizadaPorCargo().valorFormatadoTerceiroSlider}</span>
                                </div>

                                <div className={carregaInterfacePersonalizadaPorCargo().classBotoesSimulacao}>
                                    <button onClick={resetarDados}
                                        className="bg-orange-500 hover:bg-orange-700 shadow-inner shadow-gray-100 w-12 md:w-16 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-grow mr-4"
                                        style={{ minHeight: "40px" }}
                                        disabled={carregandoLimpar || carregandoSimular}
                                    >
                                        {carregandoLimpar ? (
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <ThreeDots
                                                    height="12"
                                                    width="52"
                                                    radius="9"
                                                    color="#ffffff"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClassName=""
                                                    visible={true}
                                                />
                                            </div>
                                        ) : (
                                            "Limpar"
                                        )}
                                    </button>
                                    <button
                                        onClick={calcularTrvSimuladoSlider}
                                        className="bg-green-700 hover:bg-green-900 shadow-inner shadow-gray-100 w-36 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-grow"
                                        style={{ minHeight: "40px" }}
                                        disabled={carregandoLimpar || carregandoSimular}
                                    >
                                        {carregandoSimular ? (
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <ThreeDots
                                                    height="12"
                                                    width="50"
                                                    radius="9"
                                                    color="#ffffff"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClassName=""
                                                    visible={true}
                                                />
                                            </div>
                                        ) : (
                                            "Simular"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )

};

export default TrvInterface